<template>
    <div class="item-inner">
      <p class="ellipsis" :title = "source.id+'、'+source.name">
        {{ source.id }}、{{ source.name }}
      </p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'fix-size-item',
  
    props: {
      source: {
        type: Object,
        default () {
          return {}
        }
      }
    },
    data() {
        return {
            // showPopper: false, //浮层提醒
            // tipContent:''
        }
    },
    mounted() {
    },
    methods:{
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .item-inner {
    height: 24px;
    line-height: 24px;
    padding-left: 14px;
  }
  </style>